export function decodePaymentToken(token) {
  const base64 = token
    .replace(/-/g, '+')
    .replace(/_/g, '/')
    .padEnd(Math.ceil(token.length / 4) * 4, '=');

  const bytes = Uint8Array.from(atob(base64), (char) => char.charCodeAt(0));
  const json = new TextDecoder('utf-8', { fatal: true }).decode(bytes);

  return JSON.parse(json);
}
